import { InjectionToken } from '@angular/core';
// use this token to fix circular dependencies regarding AccessService
export const ACCESS_SERVICE_TOKEN = /*#__PURE__*/new InjectionToken('AccessService');